import { render } from "./ModalKitchenDivision.vue?vue&type=template&id=e582dd2a"
import script from "./ModalKitchenDivision.vue?vue&type=script&lang=js"
export * from "./ModalKitchenDivision.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__